import { getDomainData } from "../../context-utils";
export const REGEX_EXTRACT_LANG = /^([a-z-]{2,5})_([a-z-]+)/;

// DEFAULT GEOLOC DATA
export const DEFAULT_GEOZONE_LANGUAGE_CODE = {
  ar: "other-regions-of-middle-east",
  de: "germany",
  en: "united-kingdom",
  gb: "united-kingdom",
  es: "spain",
  fr: "france",
  id: "indonesia",
  it: "italy",
  ja: "japan",
  ko: "republic-of-korea",
  nl: "netherlands",
  pl: "poland",
  pt: "portugal",
  "pt-br": "brazil",
  ru: "russia",
  sv: "sweden",
  th: "thailand",
  tr: "turkey",
  zh: "china",
};
export const LANG_LABELS = {
  de: "Deutsch",
  ru: "Русский",
  sv: "Svenska",
  pt: "Português",
  ko: "한국어",
  "pt-br": "Português",
  en: "English",
  it: "Italiano",
  fr: "Français",
  zh: "中文",
  es: "español",
  ar: "العربية",
  th: "ไทย",
  ja: "日本語",
  id: "Bahasa",
  pl: "Polski",
  nl: "Nederlands",
  tr: "Türk",
};

export const DEFAULT_GEOZONE_CONTRIBZONE =  {
  'africa': 'other-regions-of-africa',
  'asia': 'other-regions-of-asia',
  'australia': 'australia',
  'belgium': 'belgium',
  'brasil': 'brazil',
  'canada': 'canada',
  'china': 'china',
  'czech-republic-slovakia-hungary-romania': 'other-regions-of-europe',
  'denmark-norway-finland': 'denmark',
  'deutschland': 'germany',
  'espana': 'spain',
  'france': 'france',
  'india': 'india',
  'indonesia': 'indonesia',
  'ireland': 'ireland',
  'italia': 'italy',
  'japan': 'japan',
  'mexico': 'mexico',
  'middle-east': 'other-regions-of-middle-east',
  'nederland': 'netherlands',
  'new-zealand-fiji': 'new-zealand',
  'oesterreich': 'austria',
  'polska': 'poland',
  'portugal': 'portugal',
  'russia': 'russia',
  'singapore-malaysia': 'malaysia',
  'south-korea': 'republic-of-korea',
  'sudamerica': 'other-regions-of-south-america',
  'sweden': 'sweden',
  'switzerland': 'switzerland',
  'taiwan-hongkong-macao': 'hong-kong',
  'thailand': 'thailand',
  'turkey': 'turkey',
  'united-kingdom': 'united-kingdom',
  'usa': 'other-regions-of-north-america'
};

export const DEFAULT_SELECTED_GEODATA = {
  lang: "en",
  country: DEFAULT_GEOZONE_LANGUAGE_CODE["en"],
  langLabel: LANG_LABELS["en"],
  continent: "Europe",
  langWithCountry: `en_united-kingdom`,
};

export const DEFAULT_SELECTED_CURRENCY = {
  "EUR" : {
    continent: "europe",
    currency: "EUR",
    currencyLabel : "EURO",
    currencySymbol: "€"
  },
  "USD" : {
    continent: "america",
    currency: "USD",
    currencyLabel : "US DOLLAR",
    currencySymbol: "$US"
  }
};

export const LANG_SRC_REGEX = new RegExp(
  "/?(/.*)?/index.("+Object.keys(DEFAULT_GEOZONE_LANGUAGE_CODE).join("|")+").shtml"
);
export const LANG_LEG_REGEX = new RegExp(
  "(" + Object.keys(DEFAULT_GEOZONE_LANGUAGE_CODE).join("|") + ")(/)"
);

// API
export const API_ENTRY_POINT = "https://api.accor.com/referential/v1/pos";
export const API_KEY = "LJreOkXhuneMHZaeenwDZAl8DKlZGdDO";
export const GET_ACCOR_COUNTRY_LANGUAGE = "/countries";
export const SET_ACCOR_COUNTRY_LANGUAGE_MANUAL =
  "/countryLanguageManual";
export const ACCOR_COUNTRY_CODE_PARAM = "accorCountryCode";
export const LANGUAGE_CODE_PARAM = "languageCode";
export const SITE_CODE_PARAM = "siteCode";
export const SITE_CODE = getDomainData().brandName;

export const GET_CURRENCY = "/currencies";
export const GROUP_BY_CONTINENT = "groupByContinent";
export const CURRENCY_CODE_PARAM = "currencyCode";

//SESSION STORAGE
export const LOCALSTORAGE_CURRENCY_NAME = "POS.currencyDisplay";
export const LOCALSTORAGE_NAME = "POS.geolocDisplay";
export const STORAGE_EXPIRATION = 86400000;

// GEOLOC COOKIES

export const GEOLOC_BACK_COOKIE = "displayZone";
export const SET_CURRENCY_MANUAL = "/currencyManual";
export const USER_CURRENCY_COOKIE = "userCurrency";
